export const LABELS = {
  markAs: 'Mark as',
  setIssueType: 'Issue type',
}
